import { ref } from 'vue'
import { defineStore } from 'pinia'

import { generateToken } from '@/utils/tokens'

import type { ToastMessage, QueuedToastMessage } from './types'

const defaults = {
  type: 'notice',
  duration: 5000,
  queue: false
}

export const useToastStore = defineStore('toast', () => {
  const messages = ref<QueuedToastMessage[]>([])

  const alert = (message: string | ToastMessage) => {
    if (typeof message === 'string') {
      message = { message } as ToastMessage
    }
    const queued: QueuedToastMessage = {
      ...defaults,
      ...message,
      active: false,
      id: generateToken('toast-')
    }
    if (!queued.queue) {
      // remove existing messages from stack
      messages.value.map((i: QueuedToastMessage) => dismiss(i))
    }
    messages.value.push(queued)
  }

  const toggle = ({ id }: QueuedToastMessage, active: boolean) => {
    const record = messages.value.find(i => i.id === id)
    if (record) {
      record.active = active
    }
  }

  const remove = (message: QueuedToastMessage) => {
    const index = messages.value.findIndex(i => i.id === message.id)
    if (index >= 0) {
      messages.value.splice(index, 1)
    }
  }

  const dismiss = (message: QueuedToastMessage) => {
    message.active = false
    setTimeout(() => remove(message), 200)
  }

  const clear = () => {
    messages.value.forEach(i => dismiss(i))
  }

  return {
    messages,
    alert,
    toggle,
    dismiss,
    clear
  }
})

